
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { routerActions } from 'react-router-redux'
import * as R from 'ramda'
import { sort, sortSev, getByType, beautifyPhone } from 'utils/stuff'
import { managers, properties, owners } from 'selectors/entities'
import { ownerProperties } from 'selectors/owner'

import Colors from 'material-ui/styles/colors'
import TextField from 'material-ui/TextField'
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Checkbox from 'material-ui/Checkbox'
import attachmentActions from 'actions/attachmentActions'

import dataActions from 'actions/dataActions'
import AttachmentRender from 'components/AttachmentRender'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import rightStackActions from 'actions/rightStackActions'
import Error from 'components/Error'
import Deleted from 'components/Deleted'
import newCommentActions from 'actions/newCommentActions'
import EntityAttachments from 'components/EntityAttachments'
import {Tabs, Tab} from 'material-ui/Tabs'

import LeftNav from 'material-ui/Drawer'
import LeftNavMenu from 'components/LeftNavMenu'
import actionBarActions from 'actions/actionbar'
import InputPhone from 'components/InputPhone'




import Comments from 'components/Comments'
import Attachments from 'components/Attachments'
import { attachmentPath } from 'selectors/attachments'



const colors = {
	forRent: "#BA68C8",
	outOfServ: "#000",
	occupied: "#39cea8",
	retired: "#A0A0A0"
}

let select = (state, props) => ({
	...state
  ,  owners: owners(state)
  , managers: managers(state)
  , properties: properties(state)
  , ownerProperties: ownerProperties(state, props.id || props.routeParams.id)
  , path: attachmentPath(state, props.id || props.routeParams.id)
})

export class Owner extends Component{
	constructor(props){
		super(props)
		let ownerID = props.id || props.routeParams.id
		this.state ={
			phoneNumber: {
				value: (this.props.owners[ownerID])?this.props.owners[ownerID].phoneNumber : undefined
			  , selectionStart: undefined
			}
		  , editMode: false
		}
	}
	// componentDidUpdate(){
	// 	let ownerID = this.props.id || this.props.routeParams.id
	// 	if(this.props.owners[ownerID] && this.state.phoneNumber.value === undefined){
	// 		this.setState({
	// 			phoneNumber: {
	// 				value: this.props.owners[ownerID].phoneNumber
	// 			  , selectionStart: this.props.owners[ownerID].phoneNumber.length
	// 			}
	// 		})
	// 	}
	// }
	render(){
		try {
			let ownerID = this.props.id || this.props.routeParams.id
			let isMob = typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.iinerWidth < window.iinerHeight)
			return(
				<div>
					<header
						style={{
							width: "100%"
						  , height: "60px"
						  , top: "0"
						  , zIndex: "5555"
						  , backgroundColor: "#00ACC1"
						  , position: "fixed"
						  , lineHeight: "60px"
						  , paddingTop: "0"
						  , borderBottom: "1px solid #e1e3e2"
						}}
						className="action-bar form-holder"
					>
							{(typeof global.md.phone() == 'string')?
								<div
									style={{
										width: "inherit"
									  , height: "inherit"
									}}
								>
									<img
										src={"/manager/static/img/hamburger.png"}
										style={{
											maxHeight: "20%"
										  , verticalAlign: "middle"
										  , marginLeft: "21px"
										}}
										onTouchTap={this.props.TOOGLE_LEFT_NAV}
									/>
									<span
										style={{
											overflow: "hidden"
										  , textOverflow: "ellipsis"
										  , whiteSpace: "nowrap"
										  , display: "inline-block"
										  , width: "50%"
										  , verticalAlign: "middle"
										  , marginLeft: "8%"
										}}
									>
										{(this.props.owners[ownerID])?(this.props.owners[ownerID].ownerType=="business")? this.props.owners[ownerID].companyName : this.props.owners[ownerID].firstName : ""}
									</span>
									<div
										style={{
											float: "right"
										  , width: "15%"
										  , textAlign: "right"
										  , height: "inherit"
										}}
									>
										<img
											src={"/manager/static/img/trash.png"}
											style={{
												maxHeight: "40%"
											  , verticalAlign: "middle"
											  , marginRight: "21px"
											}}
											onClick={()=> {
												this.props.DOC_DELETE(ownerID)
												this.props.goBack()
											}}
										/>
									</div>
								</div>
								:
									<div id="close-project-specs"
										style={{
											lineHeight: "60px", marginLeft: "12px"
										}}
									>
										<svg
											width="17px"
											height="17px"
											viewBox="0 0 17 17"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											style={{
												verticalAlign: "middle"
											  , marginLeft: "12px"
											  , cursor: "pointer"
											  , marginRight: "10px"
											}}
											onClick={()=>{
												this.props.goBack()
											}}
										>
										    <title>Group</title>
										    <defs></defs>
										    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
										        <g id="Group" transform="translate(1.000000, 1.000000)" stroke="#FFF" strokeWidth="2">
										            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
										            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
										        </g>
										    </g>
										</svg>
										<span
											style={{
												fontSize: "24px"
											  , marginTop: "0px"
											  , marginLeft: "10px"
											  , verticalAlign: 'middle'
											  , display: "inline-block"
											  , width: "calc(100% - 29px - 50px)"
											  , textAlign: "left"
											}}
										>
											{(this.props.owners[ownerID])?(this.props.owners[ownerID].ownerType=="business")?this.props.owners[ownerID].companyName:this.props.owners[ownerID].firstName:""}
										</span>
										{(this.props.owners[ownerID])?
											<svg
												width="18px"
												height="21px"
												viewBox="0 0 49 59"
												version="1.1"
												xmlns="http://www.w3.org/2000/svg"
												xmlnsXlink="http://www.w3.org/1999/xlink"
												style={{
													verticalAlign: "middle"
												  , cursor: "pointer"
												  , position: "relative"
												  , left: "-10px"
												}}
												onClick={() => {
													document.getElementsByClassName('Prompt')[0].style.marginLeft = 0
												}}
											>
											    <title>delete</title>
											    <defs></defs>
											    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											        <g id="delete" fill="#FFF">
											            <g id="Group">
											                <path d="M24.5,51 C25.052,51 25.5,50.553 25.5,50 L25.5,17 C25.5,16.447 25.052,16 24.5,16 C23.948,16 23.5,16.447 23.5,17 L23.5,50 C23.5,50.553 23.948,51 24.5,51 L24.5,51 Z" id="Shape"></path>
											                <path d="M14.5,51 C15.052,51 15.5,50.553 15.5,50 L15.5,17 C15.5,16.447 15.052,16 14.5,16 C13.948,16 13.5,16.447 13.5,17 L13.5,50 C13.5,50.553 13.948,51 14.5,51 L14.5,51 Z" id="Shape"></path>
											                <path d="M34.5,51 C35.052,51 35.5,50.553 35.5,50 L35.5,17 C35.5,16.447 35.052,16 34.5,16 C33.948,16 33.5,16.447 33.5,17 L33.5,50 C33.5,50.553 33.948,51 34.5,51 L34.5,51 Z" id="Shape"></path>
											                <path d="M47.5,6 L33.456,6 C33.346,4.75 32.961,2.642 31.643,1.289 C30.809,0.434 29.751,0 28.499,0 L18.5,0 C17.248,0 16.19,0.434 15.356,1.289 C14.038,2.642 13.653,4.75 13.543,6 L1.5,6 C0.948,6 0.5,6.447 0.5,7 C0.5,7.553 0.948,8 1.5,8 L3.541,8 L5.456,54.021 C5.493,55.743 6.565,59 10.364,59 L38.636,59 C42.435,59 43.507,55.743 43.543,54.042 L45.459,8 L47.5,8 C48.052,8 48.5,7.553 48.5,7 C48.5,6.447 48.052,6 47.5,6 L47.5,6 Z M16.792,2.681 C17.24,2.223 17.799,2 18.5,2 L28.499,2 C29.2,2 29.759,2.223 30.207,2.681 C31.012,3.504 31.335,4.952 31.447,6 L15.553,6 C15.665,4.952 15.988,3.504 16.792,2.681 L16.792,2.681 Z M41.544,53.979 C41.538,54.288 41.4,57 38.636,57 L10.364,57 C7.63,57 7.466,54.283 7.455,53.958 L5.542,8 L43.457,8 L41.544,53.979 L41.544,53.979 Z" id="Shape"></path>
											            </g>
											        </g>
											    </g>
											</svg>
										: ''
										}
									</div>
							}
  	  					{(this.props.owners[ownerID])?
				  			<div
				  				style={{
				  					marginLeft: "100%"
				  				  , position: 'absolute'
				  				  , background: 'rgba(0,0,0,0.8)'
				  				  , padding: '11px'
				  				  , transition: 'all ease-in-out 0.3s'
				  				  , width: '100%'
				  				}}
				  				className="Prompt"
				  			>
				  				<span style={{verticalAlign: 'middle'}}>
				  					Are you sure you want to delete this item?
				  				</span>
				  				<div style={{float: "right", position:"relative", top:"-5px"}}>
				  					<FlatButton
				  						label="Yes"
				  						primary={true}

				  						onClick={()=> {
											this.props.DOC_DELETE(ownerID)
											this.props.history.push('/manager/owners')
										}}
				  					/>
				  					<FlatButton
				  						label="No"
				  						secondary={true}
				  						onClick={() => {
				  							document.getElementsByClassName('Prompt')[0].style.marginLeft = "100%"
				  						}}
				  					/>
				  				</div>
				  			</div>
							:''
						}
					</header>
					{(!this.props.owners[ownerID])?
						<Deleted />
						:
						<Tabs
							inkBarStyle={{backgroundColor: "#23987c"}}
							tabItemContainerStyle={{backgroundColor: "#3cd2ae"}}
							style={{
								marginTop: "61px"
							}}
              initialSelectedIndex={(this.props.routing.locationBeforeTransitions.query.comments)? 1 : 0}
						>
							<Tab label="GENERAL">
								<div
									style={{
											maxWidth: (this.props.id)? 'auto' : '800px'
										  , margin: "auto"
										  , marginTop: "0px"
										  , overflow: (isMob)? "auto" : 'hidden'
										  , height: (isMob)?  "calc(100vh - 133px)" : "calc(100vh - 133px)"
									}}
									speed={0.8}
									className="area"
									contentClassName="content"
									horizontal={false}
									verticalScrollbarStyle={{
										width: "20px"
									  , borderRadius: "13px"
									  , marginLeft: "3px"
									  , backgroundImage: "url(/assets/manager/img/bar.png)"
									  , backgroundSize: "100%"
									  , backgroundRepeat: "no-repeat"
									  , backgroundColor: "#f5f6f5"
									  , backgroundPosition: "center"
									  , display: (isMob)? "none" :"auto"
									}}
									minScrollSize={"50"}
									verticalContainerStyle={{
										width: "26px"
									  , backgroundColor: "#cdcdcd"
									  , opacity: "1 "
									  , display: (isMob)? "none" :"auto"
									}}
									// ref="right-panel"
									className={(typeof global.md.phone() == 'string')? "mobile-right-panel": ""}
								>
									<div className="logical-block">
										<div style={{
												color:"#000"
											  , fontSize: "24px"
											  , fontWeight: "bold"
											  , position: "absolute"
											  , textAlign: "center"
											  , width: "70px"
											  , left: "-2px"
											  , top: "52px"
											  }}>
											{
												this.props.ownerProperties ?
												this.props.ownerProperties.length:"0"
											}
										</div>
										<div style={{width: "100%"}}>
											<SelectField
												iconStyle={{
													top: "12px"
												  , right: "-10px"
												}}
												style={{
													width: "200px"
												  , marginLeft: (isMob)?"0px":"32px"
												  , paddingLeft: "10px"
												  , color: "#000000"
												  , marginTop: "0px"
												  , marginBottom: "-24px"
												}}
												underlineStyle={{borderBottom: "0px solid"}}
												labelStyle = {{
													display: "table"
												  , textAlign: "left"
												  , color: "#000000"
												  , fontSize: "14px"
												}}
												title="Type"
												hintText="Select type"
												hintStyle={{fontSize: "14px", fontStyle: "italic"}}
												onChange={(evt, indx, value) =>
													this.props.DOC_UPDATE({
														_id: ownerID
													  , ownerType: value
													  , comments: (!this.props.owners[ownerID].comments)?
															[{
																userID: this.props.session.userID
															  , auto: true, body: 'Change type'
															  , date: new Date().valueOf()
															  , value: value
															}]
															: [
																...this.props.owners[ownerID].comments
															  , {
																	userID: this.props.session.userID
																  , auto: true, body: 'Change type'
																  , date: new Date().valueOf()
																  , value: value
																}
															]
													})
												}
												value={this.props.owners[ownerID].ownerType}
											>
												<MenuItem key={1} value={"person"} primaryText="Private person" />
												<MenuItem key={2} value={"business"} primaryText="Business entity" />
											</SelectField>
										</div>
											<TextField
												hintText={(this.props.owners[ownerID].ownerType=="business")?"Enter company name":"Enter name"}
												hintStyle={{fontStyle: "italic", fontSize: "14px"}}
												multiLine = {true}
												style={{
													width: (isMob)?"calc(100% - 24px)":"370px"
												  , position: "relative"
												  , left: (isMob)?"12px ":"42px "
												  , marginBottom: (this.props.owners[ownerID].ownerType=="business")?"-20px":"-12px"
												  , marginTop: "0px"
												}}
												inputStyle={{
													fontSize: "18px"
													, fontWeight: "bold"
												}}
												underlineStyle={{
													borderBottom: "0px solid #b0bec4"
												}}
												defaultValue = {(this.props.owners[ownerID])?this.props.owners[ownerID].firstName : ""}
												errorText={(this.props.owners[ownerID]&&this.props.owners[ownerID].firstName)?"":"This field is required"}
												key={`${ownerID}-companyName`}
												onBlur={(evt)=>
													(evt.target.value.length)?
														this.props.DOC_UPDATE({
															_id: ownerID
														  , firstName: evt.target.value
														  , comments: (this.props.owners[ownerID].companyName&&evt.target.value!=this.props.owners[ownerID].companyName)?(!this.props.owners[ownerID].comments)?
																[{
																	userID: this.props.session.userID
																  , auto: true, body: 'Changed name'
																  , date: new Date().valueOf()
																  , value: evt.target.value
																}]
																: [
																	...this.props.owners[ownerID].comments
																  , {
																		userID: this.props.session.userID
																	  , auto: true, body: 'Changed name'
																	  , date: new Date().valueOf()
																	  , value: evt.target.value
																	}
																]:this.props.owners[ownerID].comments
														})
														: false
												}
											/>
										<TextField
											hintText="Enter contact name"
											hintStyle={{fontStyle: "italic", fontSize: "14px"}}
											multiLine = {true}
											style={{
												width: (isMob)?"calc(100% - 24px)":"370px"
											  , position: "relative"
											  , left: (isMob)?"12px ":"42px "
											  , marginBottom: "-12px"
											  , display: (this.props.owners[ownerID].ownerType=="business")?"":"none"
											}}
											inputStyle={{
												fontSize: (this.props.owners[ownerID].ownerType=="business")?"14px":"18px"
												, fontWeight: "bold"
											}}
											underlineStyle={{
												borderBottom: "0px solid #b0bec4"
											}}
											defaultValue = {(this.props.owners[ownerID])?this.props.owners[ownerID].contactName : ""}
											key={`${ownerID}-contactName`}
											onBlur={(evt)=>
												(evt.target.value.length)?
													this.props.DOC_UPDATE({
														_id: ownerID
													  , contactName: evt.target.value
													  , comments: (this.props.owners[ownerID].firstName&&evt.target.value!=this.props.owners[ownerID].firstName)?(!this.props.owners[ownerID].comments)?
															[{
																userID: this.props.session.userID
															  , auto: true, body: 'Changed name'
															  , date: new Date().valueOf()
															  , value: evt.target.value
															}]
															: [
																...this.props.owners[ownerID].comments
															  , {
																	userID: this.props.session.userID
																  , auto: true, body: 'Changed name'
																  , date: new Date().valueOf()
																  , value: evt.target.value
																}
															]:this.props.owners[ownerID].comments
													})
													: false
											}
										/>

										<div>
											<table style={{float: "left", marginLeft: "-6px"}}><tbody><tr>
												<td style={{display: (isMob)?"none":""}}>
													{(this.props.owners[ownerID].phoneNumber)?
														<a
															href={`call:${this.props.owners[ownerID].phoneNumber}`}
															style={{color: "#4ad4b2", position: "relative", top: "2px"}}
														>
															<i className="material-icons" style={{fontSize: "20px"}}>call</i>
														</a>
														: <i className="material-icons" style={{float: "left",  color: "#A0A0A0", fontSize: "20px", marginTop: "2px"}}>call</i>}
												</td>
												<td>
													<InputPhone
														style={{width: (isMob)?"calc(100% - 24px)":"140px"
															  , marginLeft: (isMob)?"12px":"20px"}}
														value={this.props.owners[ownerID].phoneNumber}

														key={`${ownerID}-pn`}
														inputStyle={{fontSize: "14", color: "#000000"}}

														ref={`phoneNumber-${ownerID}`}
														onBlur={(newValue)=>
															(newValue!=this.props.owners[ownerID].phoneNumber)?
																this.props.DOC_UPDATE({
																	_id: ownerID
																  , phoneNumber: newValue
																  , comments: (!this.props.owners[ownerID].comments)?
																		[{
																			userID: this.props.session.userID
																		  , auto: true, body: 'Change phone'
																		  , date: new Date().valueOf()
																		  , value: newValue
																		}]
																		: [
																			...this.props.owners[ownerID].comments
																		  , {
																				userID: this.props.session.userID
																			  , auto: true, body: 'Change phone'
																			  , date: new Date().valueOf()
																			  , value: newValue
																			}
																		]
																})
																: false
														}
													/>
												</td>
											</tr></tbody></table>
											<table style={{marginLeft: "204px"}}><tbody><tr>
												<td style={{display: (isMob)?"none":""}}>
													{(this.props.owners[ownerID].cellNumber)?
														<a
															href={`call:${this.props.owners[ownerID].cellNumber}`}
															style={{color: "#4ad4b2", position: "relative", top: "2px"}}
														>
															<svg
																width="10px"
																height="19px"
																viewBox="0 0 10 19"
																version="1.1"
																xmlns="http://www.w3.org/2000/svg"
																xmlnsXlink="http://www.w3.org/1999/xlink"
																style={{}}
															>
																<defs></defs>
																<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																	<g id="noun_192573_cc" fill="#4ad4b2">
																		<path
																			d="M9,4 L1,4 L1,15 L9,15 L9,4 L9,4 Z M7,2 L3,2 L3,3 L7,3 L7,2 L7,2 Z M5,18 C5.55,18 6,17.55 6,17 C6,16.45 5.55,16 5,16 C4.45,16 4,16.45 4,17 C4,17.55 4.45,18 5,18 L5,18 Z M8,19 L2,19 C0.9,19 0,17.93125 0,16.625 L0,2.375 C0,1.06875 0.9,0 2,0 L8,0 C9.1,0 10,1.06875 10,2.375 L10,16.625 C10,17.93125 9.1,19 8,19 L8,19 Z"
																			id="Shape"
																		>

																		</path>
																	</g>
																</g>
															</svg>
														</a>
														:
														<svg
															width="10px"
															height="19px"
															viewBox="0 0 10 19"
															version="1.1"
															xmlns="http://www.w3.org/2000/svg"
															xmlnsXlink="http://www.w3.org/1999/xlink"
															style={{}}
														>
															<defs></defs>
															<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																<g id="noun_192573_cc" fill="#A0A0A0">
																	<path
																		d="M9,4 L1,4 L1,15 L9,15 L9,4 L9,4 Z M7,2 L3,2 L3,3 L7,3 L7,2 L7,2 Z M5,18 C5.55,18 6,17.55 6,17 C6,16.45 5.55,16 5,16 C4.45,16 4,16.45 4,17 C4,17.55 4.45,18 5,18 L5,18 Z M8,19 L2,19 C0.9,19 0,17.93125 0,16.625 L0,2.375 C0,1.06875 0.9,0 2,0 L8,0 C9.1,0 10,1.06875 10,2.375 L10,16.625 C10,17.93125 9.1,19 8,19 L8,19 Z"
																		id="Shape"
																	>

																	</path>
																</g>
															</g>
														</svg>
													}
												</td>
												<td>
													<InputPhone
														style={{width: (isMob)?"calc(100% - 24px)":"140px"
															  , marginLeft: (isMob)?"12px":"16px"}}
														value={this.props.owners[ownerID].cellNumber}
														hintText="Enter cell"
														key={`${ownerID}-cn`}
														inputStyle={{fontSize: "14", color: "#000000"}}

														ref={`cellNumber-${ownerID}`}
														onBlur={(newValue)=>
															(newValue!=this.props.owners[ownerID].cellNumber)?
																this.props.DOC_UPDATE({
																	_id: ownerID
																  , cellNumber: newValue
																  , comments: (!this.props.owners[ownerID].comments)?
																		[{
																			userID: this.props.session.userID
																		  , auto: true, body: 'Change cell'
																		  , date: new Date().valueOf()
																		  , value: newValue
																		}]
																		: [
																			...this.props.owners[ownerID].comments
																		  , {
																				userID: this.props.session.userID
																			  , auto: true, body: 'Change cell'
																			  , date: new Date().valueOf()
																			  , value: newValue
																			}
																		]
																})
																: false
														}
													/>
												</td>
											</tr></tbody></table>
										</div>

										<div style={{marginTop: "0px", clear: "both", float: "left"}}>
											<table style={{float: "left", marginLeft: "-6px"}}><tbody><tr>
												<td style={{display: (isMob)?"none":""}}>
													{(this.props.owners[ownerID].email)?
														<a
															href={`mailto:${this.props.owners[ownerID].email}`}
															style={{float: "left", marginTop: "-10px", color: "#4ad4b2"
															, display: (isMob)?"none":"", marginLeft: "0px"
															}}
														>
															<i className="material-icons" style={{fontSize: "20px"}}>email</i>
														</a>
														: <i className="material-icons" style={{float: "left", color: "#A0A0A0", fontSize: "20px", marginTop: "-16px", marginLeft: "0px"}}>email</i>}
												</td>
												<td>
													<TextField
														style={{width: (isMob)?"calc(100% - 24px)":"140px"
															  , marginLeft: (isMob)?"12px":"22px", marginTop: "-20px"}}
														defaultValue={this.props.owners[ownerID].email}
														key={`${ownerID}-email`}
														hintText="Enter email"
														hintStyle={{fontStyle: "italic", fontSize: "14px"}}
														underlineStyle={{borderBottom: "0px solid"}}
														inputStyle={{fontSize: "14px"}}
														onBlur={(evt)=>
															(evt.target.value.length)?
																this.props.DOC_UPDATE({
																	_id: ownerID
																  , email: evt.target.value
																  , comments: (this.props.owners[ownerID].email&&evt.target.value!=this.props.owners[ownerID].email)?(!this.props.owners[ownerID].comments)?
																		[{
																			userID: this.props.session.userID
																		  , auto: true, body: 'Change email'
																		  , date: new Date().valueOf()
																		  , value: evt.target.value
																		}]
																		: [
																			...this.props.owners[ownerID].comments
																		  , {
																				userID: this.props.session.userID
																			  , auto: true, body: 'Change email'
																			  , date: new Date().valueOf()
																			  , value: evt.target.value
																			}
																		]:this.props.owners[ownerID].comments
																})
																: false
														}
													/>
												</td>
											</tr></tbody></table>
										</div>
										<div style={{marginTop: "-5px", clear: "both", float: "left"}}>
											<table style={{float: "left", marginLeft: "-6px"}} title="Main address"><tbody><tr>
												<td style={{display: (isMob)?"none":""}}>
													{(this.props.owners[ownerID].address)?
														<a
															target="_blank"
															href={`http://www.google.com/maps/place/${this.props.owners[ownerID].address}`}
															style={{float: "left", marginTop: "-6px", color: "#4ad4b2"
															, display: (isMob)?"none":"", marginLeft: "0px"
															}}
														>
															<i className="material-icons" style={{fontSize: "20px"}}>location_on</i>
														</a>
														: <i className="material-icons" style={{float: "left", color: "#A0A0A0", fontSize: "20px", marginTop: "-10px", marginLeft: "0px"}}>location_on</i>}
												</td>
												<td>
													<TextField
														multiLine={true}
														style={{width: (isMob)?"calc(100% - 24px)":"370px"
															  , marginLeft: (isMob)?"12px":"22px", marginTop: "-20px"}}
														defaultValue={this.props.owners[ownerID].address}
														key={`${ownerID}-address`}
														hintText="Enter main address"
														hintStyle={{fontStyle: "italic", fontSize: "14px"}}
														underlineStyle={{borderBottom: "0px solid"}}
														inputStyle={{fontSize: "14px"}}
														onBlur={(evt)=>{
															(evt.target.value.length)?
																this.props.DOC_UPDATE({
																	_id: ownerID
																  , address: evt.target.value
																  , comments: (this.props.owners[ownerID].address&&evt.target.value!=this.props.owners[ownerID].address)?(!this.props.owners[ownerID].comments)?
																		[{
																			userID: this.props.session.userID
																		  , auto: true, body: 'Change address'
																		  , date: new Date().valueOf()
																		  , value: evt.target.value
																		}]
																		: [
																			...this.props.owners[ownerID].comments
																		  , {
																				userID: this.props.session.userID
																			  , auto: true, body: 'Change address'
																			  , date: new Date().valueOf()
																			  , value: evt.target.value
																			}
																		]:this.props.owners[ownerID].comments
																})
																: false
														}}
													/>
												</td>
											</tr></tbody></table>
										</div>
										<div style={{marginLeft: "204px", marginTop: "-5px"}}>
											<table style={{float: "left", marginLeft: "-6px"}}><tbody><tr>
												<td style={{display: (isMob)?"none":""}}>
													<a
														style={{color: "#4ad4b2"}}
														href={`skype:${this.props.owners[ownerID].skype}?call`}
													>{
														(this.props.owners[ownerID].skype)?
														<img src={"/manager/static/img/skype.png"} style={{width: "20px", marginTop: "-5px"}}/>
														:
														<img src={"/manager/static/img/skype_gray.png"} style={{width: "20px", marginTop: "-5px"}}/>
														}
													</a>
												</td>
												<td>
													<TextField
														style={{width: (isMob)?"calc(100% - 24px)":"140px"
															  , marginLeft: (isMob)?"12px":"12px", marginTop: "-10px"}}
														key={`${ownerID}-skype`}
														defaultValue={(this.props.owners[ownerID].skype)?this.props.owners[ownerID].skype:""}
														hintText="Enter skype"
														inputStyle={{fontSize: "14", color: "#000000"}}
														hintStyle={{fontStyle: "italic", fontSize: "14px"}}
														underlineStyle={{borderBottom: "0px solid"}}
														onBlur={(evt)=>
															(evt.target.value.length)?
																this.props.DOC_UPDATE({
																	_id: ownerID
																  , skype: evt.target.value
																  , comments: (this.props.owners[ownerID].skype&&evt.target.value!=this.props.owners[ownerID].skype)?(!this.props.owners[ownerID].comments)?
																		[{
																			userID: this.props.session.userID
																		  , auto: true, body: 'Change skype'
																		  , date: new Date().valueOf()
																		  , value: evt.target.value
																		}]
																		: [
																			...this.props.owners[ownerID].comments
																		  , {
																				userID: this.props.session.userID
																			  , auto: true, body: 'Change skype'
																			  , date: new Date().valueOf()
																			  , value: evt.target.value
																			}
																		]:this.props.owners[ownerID].comments
																})
																: false
														}
													/>
												</td>
											</tr></tbody></table>
										</div>
										<div style={{marginTop: "-5px", clear: "both", float: "left"}}>
											<table style={{float: "left", marginLeft: "-6px", display: (this.props.owners[ownerID].ownerType=="business")?"":"none"}} title="Send checks to"><tbody><tr>
												<td style={{display: (isMob)?"none":""}}>
													{(this.props.owners[ownerID].checkAddress)?
														<a
															target="_blank"
															href={`http://www.google.com/maps/place/${this.props.owners[ownerID].checkAddress}`}
															style={{float: "left", marginTop: "-6px", color: "#4ad4b2"
															, display: (isMob)?"none":"", marginLeft: "0px"
															}}
														>
															<i className="material-icons" style={{fontSize: "20px"}}>markunread_mailbox</i>
														</a>
														: <i className="material-icons" style={{float: "left", color: "#A0A0A0", fontSize: "20px", marginTop: "-10px", marginLeft: "0px"}}>markunread_mailbox</i>}
												</td>
												<td>
													<TextField
														multiLine={true}
														style={{width: (isMob)?"calc(100% - 24px)":"370px"
															  , marginLeft: (isMob)?"12px":"22px", marginTop: "-20px"}}
														defaultValue={this.props.owners[ownerID].checkAddress}
														key={`${ownerID}-checkAddress`}
														hintText="Enter address for checks"
														hintStyle={{fontStyle: "italic", fontSize: "14px"}}
														underlineStyle={{borderBottom: "0px solid"}}
														inputStyle={{fontSize: "14px"}}
														onBlur={(evt)=>{
															(evt.target.value.length)?
																this.props.DOC_UPDATE({
																	_id: ownerID
																  , checkAddress: evt.target.value
																  , comments: (this.props.owners[ownerID].checkAddress&&evt.target.value!=this.props.owners[ownerID].checkAddress)?(!this.props.owners[ownerID].comments)?
																		[{
																			userID: this.props.session.userID
																		  , auto: true, body: 'Change address'
																		  , date: new Date().valueOf()
																		  , value: evt.target.value
																		}]
																		: [
																			...this.props.owners[ownerID].comments
																		  , {
																				userID: this.props.session.userID
																			  , auto: true, body: 'Change address'
																			  , date: new Date().valueOf()
																			  , value: evt.target.value
																			}
																		]:this.props.owners[ownerID].comments
																})
																: false
														}}
													/>
												</td>
											</tr></tbody></table>
										</div>
										<div style={{marginTop: "-5px", clear: "both", float: "left"}}>
											<table style={{float: "left", marginLeft: "-6px", display: (this.props.owners[ownerID].ownerType=="business")?"":"none"}} title="EIN"><tbody><tr>
												<td style={{display: (isMob)?"none":""}}>
													{/*(this.props.owners[ownerID].iin)?
														<a
															target="_blank"
															to={`http://binlists.com/${this.props.owners[ownerID].iin}`}
															style={{float: "left", marginTop: "-6px", color: "#4ad4b2"
															, display: (isMob)?"none":"", marginLeft: "0px"
															}}
														>
															<i className="material-icons" style={{fontSize: "20px"}}>payment</i>
														</a>
														: <i className="material-icons" style={{float: "left", color: "#A0A0A0", fontSize: "20px", marginTop: "-10px", marginLeft: "0px"}}>payment</i>
														*/}
														<p style={{fontSize: "14px", marginTop: "4px", position: "relative", left: "-4px", marginRight: "-10px"}}>EIN: </p>
												</td>
												<td>

													<TextField
														multiLine={true}
														style={{width: (isMob)?"calc(100% - 24px)":"370px"
															  , marginLeft: (isMob)?"12px":"22px", marginTop: "-20px"}}
														defaultValue={this.props.owners[ownerID].iin}
														key={`${ownerID}-iin`}
														hintText="Enter EIN"
														hintStyle={{fontStyle: "italic", fontSize: "14px"}}
														underlineStyle={{borderBottom: "0px solid"}}
														inputStyle={{fontSize: "14px"}}
														onBlur={(evt)=>{
															(evt.target.value.length)?
																this.props.DOC_UPDATE({
																	_id: ownerID
																  , iin: evt.target.value
																  , comments: (this.props.owners[ownerID].iin&&evt.target.value!=this.props.owners[ownerID].iin)?(!this.props.owners[ownerID].comments)?
																		[{
																			userID: this.props.session.userID
																		  , auto: true, body: 'Change iin'
																		  , date: new Date().valueOf()
																		  , value: evt.target.value
																		}]
																		: [
																			...this.props.owners[ownerID].comments
																		  , {
																				userID: this.props.session.userID
																			  , auto: true, body: 'Change iin'
																			  , date: new Date().valueOf()
																			  , value: evt.target.value
																			}
																		]:this.props.owners[ownerID].comments
																})
																: false
														}}
													/>
												</td>
											</tr></tbody></table>
										</div>
									</div>

									<div className="logical-block" style={{clear: "both"}}>
										<p style={{fontSize: "16px", fontWeight: "bold", color: "#909090", marginTop: "0px", marginLeft: "44px"}}>Portfolio:</p>
										{
											(this.props.ownerProperties && this.props.ownerProperties.length)?
												R.map((property) => (
													(property)?
														<div key={`inst-${Math.random(1)}`} style={{clear: "both"}}>
															<div style={{height: "32px"}}>
																{(this.props.properties[property._id])?
																	<Link
																		to={`/manager/property/${property._id}/`}
																		style={{
																			textDecoration: 'none'
																		  , color: 'inherit'
																		}}
																	>
																		<svg
																			width="30px"
																			height="30px"
																			viewBox="0 0 78 76"
																			version="1.1"
																			xmlns="http://www.w3.org/2000/svg"
																			xmlnsXlink="http://www.w3.org/1999/xlink"
																			className="left-navigation-icons"
																			style={{
																				width: "20px"
																			  , height: "20px"
																			  , marginLeft: "3px"
																			  , marginTop: "-3px"
																			  , float: "left"
																			  , position: "relative"
																			  , left: "-8px"
																			  , marginRight: "20px"
																			}}
																		>
																			<title>properties</title>
																			<defs></defs>
																			<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																				<g id="properties" fill={(this.props.properties[property._id].status=='For Rent')?colors.forRent:
																					(this.props.properties[property._id].status=='Occupied')?colors.occupied:
																					(this.props.properties[property._id].status=='Retired')?colors.retired:
																					(this.props.properties[property._id].status=='Out Of Service'||this.props.properties[property._id].status=='Not In Service')?colors.outOfServ: "#A0A0A0"}>
																					<path d="M77.249,34.53 L40.426,1.599 C40.362,1.542 40.292,1.498 40.223,1.451 C39.497,0.745 38.342,0.703 37.575,1.389 L0.751,34.321 C-0.05,35.037 -0.119,36.268 0.598,37.069 C0.982,37.499 1.515,37.718 2.049,37.718 C2.511,37.718 2.974,37.555 3.345,37.222 L10.356,30.952 L10.356,32.61 L10.356,49.802 L10.356,69.865 C10.356,72.754 12.706,75.104 15.595,75.104 C15.639,75.104 15.681,75.094 15.724,75.091 C15.768,75.094 15.809,75.104 15.853,75.104 L27.22,75.104 C29.79,75.104 31.881,73.11 32.085,70.592 C32.111,70.465 32.125,70.334 32.125,70.199 L32.125,50.679 C32.125,50.121 32.579,49.667 33.137,49.667 L44.864,49.667 C45.422,49.667 45.876,50.121 45.876,50.679 L45.876,70.199 C45.876,70.334 45.89,70.465 45.916,70.592 C46.12,73.11 48.211,75.104 50.781,75.104 L62.405,75.104 C65.343,75.104 67.644,72.19 67.644,68.471 L67.644,50.583 L67.644,45.103 L67.644,31.161 L74.655,37.431 C75.026,37.763 75.49,37.927 75.952,37.927 C76.486,37.927 77.019,37.708 77.403,37.278 C78.119,36.477 78.05,35.247 77.249,34.53 L77.249,34.53 Z M63.751,45.103 L63.751,50.583 L63.751,68.47 C63.751,70.17 62.879,71.211 62.404,71.211 L50.78,71.211 C50.222,71.211 49.768,70.757 49.768,70.199 L49.768,50.679 C49.768,47.975 47.568,45.775 44.864,45.775 L33.137,45.775 C30.433,45.775 28.233,47.975 28.233,50.679 L28.233,70.199 C28.233,70.757 27.779,71.211 27.221,71.211 L15.854,71.211 C15.81,71.211 15.768,71.221 15.725,71.224 C15.681,71.221 15.64,71.211 15.596,71.211 C14.853,71.211 14.249,70.607 14.249,69.864 L14.249,49.801 L14.249,32.609 L14.249,27.47 L38.883,5.44 L63.752,27.68 L63.752,45.103 L63.751,45.103 Z" id="Shape"></path>
																				</g>
																			</g>
																		</svg>
																	</Link>
																	:
																	""
																}
																{(this.props.properties[property._id])?this.props.properties[property._id].alias:`Deleted property ID${property}`}
														</div>
														</div> : <div key={`hm-${Math.random(1)}`}><span style={{color: "#FF0000"}}>Error data</span></div>
												), this.props.ownerProperties)
											:
											<span style={{fontStyle: "italic", color: "#909090"}}>Empty</span>
										}
									</div>

									<div className="logical-block" style={{clear: "both"}}>
										<Attachments objectID={ownerID} path={this.props.path} removable={true}/>
									</div>

									<br/>
								</div>
							</Tab>

							<Tab
								label={
									<span>Comments (
										{(this.props.owners[ownerID].comments&&this.props.owners[ownerID].comments.length)? R.filter(comment => !comment.auto && comment.body, this.props.owners[ownerID].comments).length:"0"}
									)
									</span>
								}

							>
								<div
									style={{
											maxWidth: (this.props.id)? 'auto' : '800px'
										  , margin: "auto"
										  , marginTop: "0"
										  , overflow: (isMob)? "auto" : 'hidden'
										  , height: (typeof global.md.phone() == 'string')? "100vh" : "calc(100vh - 97px)"
										  , paddingRight: (this.props.owners[ownerID].comments.length > 5)? "30px" : "0"
									}}
									speed={0.8}
									className="area"
									contentClassName="content"
									horizontal={false}
									verticalScrollbarStyle={{
										width: "16px"
									  , borderRadius: "13px"
									  , marginLeft: "1px"
									  , backgroundImage: "url(/assets/manager/img/bar.png)"
									  , backgroundSize: "100%"
									  , backgroundRepeat: "no-repeat"
									  , backgroundColor: "#f5f6f5"
									  , backgroundPosition: "center"
									  , display: (isMob)? "none" :"auto"
									}}
									minScrollSize={30}
									verticalContainerStyle={{
										width: "18px"
									  , backgroundColor: "#cdcdcd"
									  , opacity: "1 "
									  , display: (isMob)? "none" :"auto"
									}}
									// ref="right-panel"
									className={(typeof global.md.phone() == 'string')? "mobile-right-panel": ""}
								>
									<Comments objectID={ownerID} path={this.props.path} />
								</div>
							</Tab>


						</Tabs>
					}
				</div>
			)
		}catch(err){
			console.error(err)
			return(<Error />)
		}
	}
}

export default connect(select, R.mergeAll([dataActions, routerActions, attachmentOverlayActions, newCommentActions, rightStackActions, attachmentActions, actionBarActions]))(Owner)



// WEBPACK FOOTER //
// ./src/routes/manager/ownerForm/index.js